// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pattern-editor-status {
    background-color: #eee;
    padding: 5px;
}

.pattern-editor-status:after {
    content: '';
    display: table;
    clear: both;
}

.pattern-editor-status .octave-status {
    float: left;
    padding: 0 10px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/panels/pattern_editor.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB","sourcesContent":[".pattern-editor-status {\n    background-color: #eee;\n    padding: 5px;\n}\n\n.pattern-editor-status:after {\n    content: '';\n    display: table;\n    clear: both;\n}\n\n.pattern-editor-status .octave-status {\n    float: left;\n    padding: 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
